module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src500842655/src/html5-media-tool-angular/~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module chunks = 2